export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9924.35b14f38.jpg";